module.exports = __webpack_public_path__ + "static/media/youtube.7c9173c4.svg";